import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import { useArchetypes } from '../context/ContentContext';
import { StoryCard } from './StoryCard';
import { useDownloadStoryCard } from '../hooks/useDownloadStoryCard';

/**
 * Standalone preview route at /share/:archetypeKey (e.g. /share/visionary)
 * so Kara can screenshot or share a preview without taking the quiz.
 * Scaled to fit the viewport but rasterized at full 1080x1920.
 */
export default function StandaloneSharePage() {
  const { archetypeKey } = useParams();
  const archetypes = useArchetypes();
  const archetype = archetypes[(archetypeKey || '').toLowerCase()];
  const { ref, download, busy } = useDownloadStoryCard();

  if (!archetype) {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: '#6d655a' }}>
        <h1 className="font-heading text-[36px]" style={{ color: '#3D3830' }}>Archetype not found</h1>
        <p className="font-body mt-3">
          Try one of: visionary, warrior, scholar, feeler, oracle, nurturer.
        </p>
        <Link to="/" className="inline-block mt-6 btn-ghost">Back to quiz</Link>
      </div>
    );
  }

  return (
    <section
      data-testid="share-page"
      className="mx-auto w-full max-w-[720px] px-5 sm:px-8 pt-10 pb-20 text-center"
    >
      <p className="section-label mb-3">Story card preview</p>
      <h1 className="font-heading text-[30px] sm:text-[36px] mb-5" style={{ color: '#3D3830', fontWeight: 500 }}>
        {archetype.name}. 1080×1920 share card
      </h1>

      <div
        className="mx-auto overflow-hidden rounded-2xl"
        style={{
          width: '100%',
          maxWidth: 360,
          aspectRatio: '9 / 16',
          boxShadow: 'none',
          border: '1px solid rgba(206,197,212,0.45)',
        }}
      >
        {/* Scaled preview */}
        <div
          style={{
            transform: 'scale(0.333)',
            transformOrigin: 'top left',
            width: 1080,
            height: 1920,
          }}
        >
          <StoryCard ref={ref} archetype={archetype} />
        </div>
      </div>

      <div className="mt-8">
        <button
          data-testid="share-download-button"
          onClick={() => download(`my-birth-archetype-${archetype.key}.png`)}
          disabled={busy}
          className="btn-primary"
        >
          <Download size={14} strokeWidth={1.6} />
          {busy ? 'Preparing your card…' : 'Download PNG'}
        </button>
        <div className="mt-5">
          <Link to="/" className="btn-ghost inline-block">Back to quiz</Link>
        </div>
      </div>
    </section>
  );
}
